// Add Body Class
(function addPageClassToBody() {
  function applyClass() {
    // 1. Get pathname and strip query strings / trailing slashes
    const path = window.location.pathname.replace(/\/+$/, '');

    // 2. Default class for homepage
    if (!path || path === '') {
      document.body.classList.add('page-home');
      return;
    }

    // 3. Get the last URL segment (e.g., "about-us" from "/pages/about-us")
    const segments = path.split('/').filter(Boolean);
    const lastSegment = segments[segments.length - 1];

    // 4. Sanitize to ensure a valid CSS class name
    const sanitizedSlug = lastSegment
      .toLowerCase()
      .replace(/[^a-z0-9_-]/g, '-'); // Replace special chars with hyphens

    if (sanitizedSlug) {
      document.body.classList.add(`page-${sanitizedSlug}`);
    }
  }

  // Run immediately if DOM is ready, or wait for load
  if (document.readyState !== 'loading') {
    applyClass();
  } else {
    document.addEventListener('DOMContentLoaded', applyClass);
  }
})();

// ═══ SOLÈY GUMMIES THEME INTERACTIVE JS ═══
// NAV STICKY SCROLL
function updateNavScroll() {
  const nav = document.getElementById('nav') || document.querySelector('.nav');
  if (!nav) return;

  // Normalize path (e.g. converts '/fr/' and '/fr' both to '/fr')
  const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
  const rootPath = (window.Shopify?.routes?.root || '/').replace(/\/+$/, '') || '/';

  // Check path, liquid routes, and common theme body classes
  const isHomepage = 
    currentPath === rootPath || 
    document.body.classList.contains('template-index') ||
    document.body.className.includes('index');

  if (isHomepage) {
    nav.classList.toggle('sc', window.scrollY > 60);
  } else {
    nav.classList.add('sc');
  }
}

// Execute immediately if script loads late, otherwise on DOM load
if (document.readyState !== 'loading') {
  updateNavScroll();
} else {
  document.addEventListener('DOMContentLoaded', updateNavScroll);
}

window.addEventListener('scroll', updateNavScroll, { passive: true });

// 2. FAQ ACCORDION
function toggleFaq(btn) {
  if (!btn) return;
  
  // Stop event from bubbling to document listener in twd-2.js
  if (window.event) {
    window.event.stopPropagation();
  }

  const parent = btn.closest('.faq-item');
  if (parent) {
    const isOpen = parent.classList.toggle('open');
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }
}

// 3. CART SYSTEM & PERSISTENCE (LocalStorage + Shopify Sync)
const PRODS = {
  somnia: {
    name: 'Somnia',
    sub: 'Sommeil · Goût Fruits de la Passion',
    price: 24.90,
    cls: 'ci-s',
    img: 'https://soleygummies.com/cdn/shop/files/somnia-1.jpg?v=1784732677&width=1000'
  },
  shine: {
    name: 'Shine',
    sub: 'Cheveux & Ongles · Goût Mangue',
    price: 24.90,
    cls: 'ci-sh',
    img: 'https://soleygummies.com/cdn/shop/files/Shine-1.jpg?v=1784732535&width=1000'
  }
};
let cart = {};
let soleyCartQueue = Promise.resolve();
function soleyRoot() {
  return window.Shopify?.routes?.root || '/';
}
async function requestSoleyCart(path, payload) {
  const response = await fetch(soleyRoot() + path, payload ? {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  } : undefined);
  const data = await response.json();
  if (!response.ok) throw new Error(data.description || data.message || 'Impossible de mettre à jour le panier. Réessaie.');
  return data;
}
function queueSoleyCart(operation) {
  const result = soleyCartQueue.then(operation);
  soleyCartQueue = result.catch(() => {});
  return result;
}
function addSoleyItems(items) {
  return queueSoleyCart(async () => {
    if (items.some(item => !Number.isSafeInteger(Number(item.id)) || Number(item.id) <= 0 || !Number.isInteger(item.quantity) || item.quantity < 1)) {
      throw new Error('Ce produit est indisponible pour le moment.');
    }
    await requestSoleyCart('cart/add.js', { items });
    await syncFromShopifyCart(true);
  });
}


function saveCart() {
  try {
    localStorage.setItem('soley_cart_v3', JSON.stringify(cart));
  } catch (e) {
    console.warn('LocalStorage save error:', e);
  }
}

function loadCart() {
  try {
    const saved = localStorage.getItem('soley_cart_v3');
    if (saved) {
      cart = JSON.parse(saved);
    }
  } catch (e) {
    console.warn('LocalStorage load error:', e);
    cart = {};
  }
}

function getQty(id) {
  if (typeof cart[id] === 'number') return cart[id];
  if (cart[id] && typeof cart[id].qty === 'number') return cart[id].qty;
  return 0;
}

function setQty(id, qty, variantId = null) {
  if (qty <= 0) {
    delete cart[id];
  } else {
    const existingVarId = (cart[id] && typeof cart[id] === 'object') ? cart[id].variantId : null;
    cart[id] = {
      qty: qty,
      variantId: variantId || existingVarId
    };
  }
  saveCart();
}

async function addToCart(id, qty = 1, variantId = null) {
  try {
    const resolvedId = Number(variantId || await resolveShopifyVariantId(id));
    await addSoleyItems([{ id: resolvedId, quantity: Number(qty) }]);
    openCart();
    showToast((PRODS[id]?.name || id) + ' ajouté !');
    return true;
  } catch (error) {
    showToast(error.message);
    return false;
  }
}

async function addBundle(somniaVarId = null, shineVarId = null) {
  try {
    const somniaId = Number(somniaVarId || await resolveShopifyVariantId('somnia'));
    const shineId = Number(shineVarId || await resolveShopifyVariantId('shine'));
    if (somniaId === shineId) throw new Error('Le duo est indisponible pour le moment.');
    await addSoleyItems([{ id: somniaId, quantity: 1 }, { id: shineId, quantity: 1 }]);
    openCart();
    showToast('✦ Duo Solèy ajouté · livraison offerte !');
    return true;
  } catch (error) {
    showToast(error.message);
    return false;
  }
}

async function changeQty(id, d) {
  try {
    await queueSoleyCart(async () => {
      await syncFromShopifyCart(true);
      const item = cart[id];
      if (!item) return;
      const quantity = d === -999 ? 0 : Math.max(0, item.qty + d);
      await requestSoleyCart('cart/change.js', { id: item.lineKey, quantity });
      await syncFromShopifyCart(true);
    });
  } catch (error) {
    showToast(error.message);
  }
}

function getTotalBoxes() {
  return Object.keys(cart).reduce((sum, key) => sum + getQty(key), 0);
}

function getTotalPrice() {
  return Object.keys(cart).reduce((sum, key) => {
    const q = getQty(key);
    const price = PRODS[key] ? PRODS[key].price : 24.90;
    return sum + price * q;
  }, 0);
}

function getShipping() {
  return getTotalBoxes() >= 2 ? 0 : 4.90;
}

function renderCart() {
  const keys = Object.keys(cart).filter(k => getQty(k) > 0);
  const empty = document.getElementById('cartEmpty');
  const items = document.getElementById('cartItems');
  const totalEl = document.getElementById('cartTotal');
  const shipEl  = document.getElementById('cartShipNote');
  if (!empty || !items || !totalEl || !shipEl) return;
  if (!keys.length) {
    empty.style.display = 'block';
    items.innerHTML = '';
    totalEl.textContent = '0,00€';
    shipEl.textContent = 'Livraison offerte dès 2 boîtes';
    shipEl.className = 'cart-ship-note';
    updateBadge(0);
    return;
  }
  empty.style.display = 'none';
  const ship = getShipping();
  const sub  = getTotalPrice();
  items.innerHTML = keys.map(id => {
    const p = PRODS[id] || {
  name: id,
  sub: '',
  price: 24.90,
  cls: 'ci-s',
  img: 'https://soleygummies.com/cdn/shop/files/somnia-1.jpg?v=1784732677&width=1000'
};
    const q = getQty(id);
    return `<div class="cart-item">
      <div class="ci-ico ${p.cls}">
  <img src="${p.img}" alt="${p.name}">
</div>
      <div>
        <div class="ci-name">${p.name}</div>
        <div class="ci-sub">${p.sub}</div>
        <div class="ci-qty">
          <button class="cq-btn" onclick="changeQty('${id}',-1)" type="button" aria-label="Retirer une boîte ${p.name}">−</button>
          <span class="cq-val" aria-label="Quantité">${q}</span>
          <button class="cq-btn" onclick="changeQty('${id}',1)" type="button" aria-label="Ajouter une boîte ${p.name}">+</button>
          <button class="ci-rm" type="button" onclick="changeQty('${id}',-999)" style="background:none;border:0;padding:0;font-family:inherit;">Supprimer</button>
        </div>
      </div>
      <div class="ci-price">${(p.price * q).toFixed(2).replace('.', ',')}€</div>
    </div>`;
  }).join('');
  totalEl.textContent = (sub + ship).toFixed(2).replace('.', ',') + '€';
  if (ship === 0) {
    shipEl.textContent = '✓ Livraison offerte incluse';
    shipEl.className = 'cart-ship-note free';
  } else {
    shipEl.textContent = 'Livraison 4,90€ incluse · offerte dès 2 boîtes';
    shipEl.className = 'cart-ship-note';
  }
  updateBadge(getTotalBoxes());
}

function updateBadge(n) {
  let b = document.getElementById('cartBadge');
  if (!b) {
    b = document.createElement('span');
    b.id = 'cartBadge';
    b.setAttribute('aria-label', 'boîtes dans le panier');
    b.style.cssText = 'position:absolute;top:-6px;right:-6px;background:#fff;color:var(--terra);border-radius:50%;width:19px;height:19px;font-size:10px;font-weight:700;display:flex;align-items:center;justify-content:center;border:2px solid var(--terra);box-shadow:0 2px 6px rgba(0,0,0,.2);';
    const btn = document.getElementById('navCart') || document.querySelector('.nav-cart');
    if (btn) {
      btn.style.position = 'relative';
      btn.appendChild(b);
    }
  }
  if (b) {
    b.textContent = n;
    b.style.display = n > 0 ? 'flex' : 'none';
  }
}

// 4. CART DRAWER OPEN / CLOSE & OVERLAY CLICK
let soleyCartReturnFocus = null;
function openCart() {
  const drawer = document.getElementById('cartDrawer');
  if (drawer && !drawer.classList.contains('open')) {
    soleyCartReturnFocus = document.activeElement;
  }
  document.querySelectorAll('.cart-drawer, #cartDrawer').forEach(el => { el.classList.add('open'); el.setAttribute('aria-hidden', 'false'); });
  document.querySelectorAll('.cart-ov, #cartOv').forEach(el => el.classList.add('open'));
  document.body.style.overflow = 'hidden';
  const nav = document.getElementById('navCart');
  if (nav) nav.setAttribute('aria-expanded', 'true');
  if (drawer) {
    const first = drawer.querySelector('.cart-x') || drawer;
    setTimeout(() => first.focus(), 50);
  }
}

function closeCart() {
  const drawer = document.getElementById('cartDrawer');
  const wasOpen = drawer && drawer.classList.contains('open');
  document.querySelectorAll('.cart-drawer, #cartDrawer').forEach(el => { el.classList.remove('open'); el.setAttribute('aria-hidden', 'true'); });
  document.querySelectorAll('.cart-ov, #cartOv').forEach(el => el.classList.remove('open'));
  document.body.style.overflow = '';
  const nav = document.getElementById('navCart');
  if (nav) nav.setAttribute('aria-expanded', 'false');
  if (wasOpen && soleyCartReturnFocus && typeof soleyCartReturnFocus.focus === 'function') {
    soleyCartReturnFocus.focus();
  }
  soleyCartReturnFocus = null;
}

// Keep keyboard focus inside the open cart drawer
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Tab') return;
  const drawer = document.getElementById('cartDrawer');
  if (!drawer || !drawer.classList.contains('open')) return;
  const focusables = Array.from(drawer.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])')).filter(el => !el.disabled && el.offsetParent !== null);
  if (!focusables.length) return;
  const first = focusables[0];
  const last = focusables[focusables.length - 1];
  if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
});

// 5. SHOPIFY AJAX CART SYNC & VARIANT RESOLVER (WITH PRODUCTS.JSON FALLBACK)
let cachedStoreProducts = null;

async function fetchAllStoreProducts() {
  if (cachedStoreProducts) return cachedStoreProducts;
  try {
    const res = await fetch('/products.json?limit=250');
    if (res.ok) {
      const data = await res.json();
      if (data && data.products) {
        cachedStoreProducts = data.products;
        return cachedStoreProducts;
      }
    }
  } catch (e) {
    console.warn('Could not fetch store products.json:', e);
  }
  return [];
}

async function syncItemToShopify(variantId, qty) {
  if (!variantId || isNaN(variantId)) return;
  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    });
  } catch (e) {
    console.warn('Background Shopify cart sync error:', e);
  }
}

// FIXED: Using /cart/update.js instead of /cart/change.js to prevent 400 errors
async function syncChangeToShopify(variantId, qty) {
  if (!variantId || isNaN(variantId)) return;
  try {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates: {
          [Number(variantId)]: Math.max(0, qty)
        }
      })
    });
  } catch (e) {
    console.warn('Background Shopify cart update error:', e);
  }
}

async function syncFromShopifyCart(strict = false) {
  try {
    const shopifyCart = await requestSoleyCart('cart.js');
    const nextCart = {};
    shopifyCart.items.forEach(item => {
      const handle = (item.handle || '').toLowerCase();
      const baseKey = handle.includes('somnia') ? 'somnia' : handle.includes('shine') ? 'shine' : String(item.variant_id);
      const key = nextCart[baseKey] ? String(item.key) : baseKey;
      nextCart[key] = { qty: item.quantity, variantId: item.variant_id, lineKey: item.key };
      const known = PRODS[baseKey];
      PRODS[key] = {
        name: known?.name || item.product_title || item.title,
        sub: known?.sub || '',
        price: item.final_price / 100,
        cls: known?.cls || 'ci-s',
        img: item.image || known?.img || ''
      };
    });
    cart = nextCart;
    saveCart();
    renderCart();
  } catch (error) {
    if (strict) throw error;
    console.warn('Sync from Shopify cart failed:', error);
  }
}

async function resolveShopifyVariantId(idOrHandle) {
  if (Number.isSafeInteger(Number(idOrHandle)) && Number(idOrHandle) > 1000) return Number(idOrHandle);
  const handle = String(idOrHandle).toLowerCase().trim();
  const candidates = Array.from(document.querySelectorAll('[data-handle][data-variant-id]'));
  const matching = candidates.find(el => el.dataset.handle.toLowerCase() === handle);
  if (matching && Number(matching.dataset.variantId) > 1000) return Number(matching.dataset.variantId);
  const response = await fetch(soleyRoot() + 'products/' + encodeURIComponent(handle) + '.js');
  if (!response.ok) return null;
  const product = await response.json();
  return product.variants?.find(variant => variant.available)?.id || null;
}

async function goCheckout() {
  const buttons = Array.from(document.querySelectorAll('.cart-checkout'));
  if (buttons.some(button => button.disabled)) return;
  const labels = buttons.map(button => button.innerHTML);
  buttons.forEach(button => { button.disabled = true; button.textContent = 'Redirection... 🔒'; });
  try {
    await soleyCartQueue;
    await syncFromShopifyCart(true);
    if (!getTotalBoxes()) throw new Error('Ton panier est vide.');
    window.location.href = soleyRoot() + 'checkout';
  } catch (error) {
    showToast(error.message);
    buttons.forEach((button, index) => { button.disabled = false; button.innerHTML = labels[index]; });
  }
}

// 6. TOAST NOTIFICATION
function showToast(msg) {
  const t = document.getElementById('toast');
  const tm = document.getElementById('toastMsg');
  if (!t || !tm) return;
  tm.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 3200);
}

// 7. FLOATING BUYBAR ON SCROLL
function updateBuybarVisibility() {
  const bb = document.getElementById('buybar') || document.getElementById('buyBar') || document.querySelector('.buybar') || document.querySelector('.buy-bar');
  const hero = document.getElementById('hero') || document.querySelector('.hero') || document.querySelector('.hero-glow');
  if (!bb) return;
  const scrollPos = window.scrollY || window.pageYOffset;
  const heroHeight = hero ? (hero.getBoundingClientRect().top + scrollPos + hero.offsetHeight) : 400;
  const footer = document.querySelector('footer');
  const footerTop = footer ? footer.getBoundingClientRect().top : 99999;
  const shouldShow = scrollPos > heroHeight - 150 && footerTop > window.innerHeight;
  bb.classList.toggle('show', shouldShow);
  bb.classList.toggle('visible', shouldShow);
}
window.addEventListener('scroll', updateBuybarVisibility, { passive: true });
document.addEventListener('DOMContentLoaded', updateBuybarVisibility);

// 8. EMAIL POPUP
(function() {
  try { if (sessionStorage.getItem('soley_pop')) return; } catch (error) {}
  let shown = false;
  function show() {
    if (shown) return;
    shown = true;
    const pop = document.getElementById('emailPopup') || document.querySelector('.popup-ov');
    if (pop) {
      pop.classList.add('open');
      document.body.style.overflow = 'hidden';
    }
  }
  document.addEventListener('mouseleave', function(e) { if (e.clientY <= 0) show(); });
  setTimeout(show, 50000);
})();

function closePopup() {
  const pop = document.getElementById('emailPopup') || document.querySelector('.popup-ov');
  if (pop) pop.classList.remove('open');
  document.body.style.overflow = '';
  try { sessionStorage.setItem('soley_pop', '1'); } catch (error) {}
}

function submitPopup() {
  const e = document.getElementById('popupEmail');
  if (e && !e.value.includes('@')) {
    e.style.borderColor = 'var(--terra)';
    return;
  }
  closePopup();
  showToast('🎁 Code -10% envoyé ! Vérifie ta boîte mail.');
}

// 9. INITIALIZATION & EVENT LISTENERS
document.addEventListener('DOMContentLoaded', function() {
  loadCart();
  renderCart();
  syncFromShopifyCart();
  document.addEventListener('click', function(e) {
    if (e.target && (e.target.classList.contains('cart-ov') || e.target.id === 'cartOv')) {
      closeCart();
    }
    if (e.target && (e.target.classList.contains('popup-ov') || e.target.id === 'emailPopup')) {
      closePopup();
    }
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeCart();
      closePopup();
    }
  });
  updateNavScroll();
  updateBuybarVisibility();
});








